import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  //   Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "2022", value: 490 },
  { name: "2023", value: 501 },
  { name: "2024", value: 585 },
  { name: "2025", value: 600 },
  { name: "2026", value: 800 },
  { name: "2027", value: 950 },
  { name: "2028", value: 1100 },
  { name: "2029", value: 1350 },
  { name: "2030", value: 1590 },
  { name: "2031", value: 1800 },
  { name: "2032", value: 2300 },
];

// const renderCustomTooltip = ({ payload }) => {
//   if (payload && payload.length > 0) {
//     const dataPoint = payload[0].payload;
//     return (
//       <div className="custom-tooltip">
//         <p>{dataPoint.name}</p>
//         <p
//           style={{ color: "rgb(53, 162, 235)" }}
//         >{`Number of global active device connections in billions: ${dataPoint.value}`}</p>
//       </div>
//     );
//   }
//   return null;
// };

const HmcCloudComputingChart = () => {
  return (
    <div>
      <div className="ml-16 mb-7">
        <p className="text-left text-base font-bold mb-0">
          Cloud Computing Market Size
        </p>
        <span>($ Billions)</span>
        <sup className="text-[10px]">3</sup>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" />
          <YAxis tickFormatter={(value) => `$${value.toLocaleString()}`} />
          {/* <Tooltip content={renderCustomTooltip} /> */}
          {/* <Tooltip /> */}
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="#C39F5C"
            animationBegin={500}
            animationDuration={1000}
            barSize={15}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HmcCloudComputingChart;
